<app-expansion-panel [title]="title()">
  <div class="customer-profile-panel__content">
    <div class="customer-profile-panel__cards">
      <app-card class="customer-profile-panel__left">
        <span cardTitle i18n>{{
          isPersonalAccount ? 'Client' : 'Entreprise'
        }}</span>
        <div cardRows class="card__rows">
          <div class="card__row">
            <span class="card__label" i18n>Prénom</span>
            <span class="card__value">{{
              asDisplayValue(userProfile()?.firstName)
            }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Nom</span>
            <span class="card__value">{{
              asDisplayValue(userProfile()?.lastName)
            }}</span>
          </div>
          @if (isPersonalAccount) {
            <div class="card__row">
              <span class="card__label" i18n>Nationalité</span>
              <span class="card__value">{{ nationalityLabel }}</span>
            </div>
          }
          <div class="card__row">
            <span class="card__label" i18n>Email</span>
            <span class="card__value">{{
              asDisplayValue(userProfile()?.email)
            }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>N° de téléphone</span>
            <span class="card__value">{{ phoneNumber }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Adresse</span>
            <span class="card__value">{{
              asDisplayValue(userProfile()?.address)
            }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Ville</span>
            <span class="card__value">{{
              asDisplayValue(userProfile()?.city)
            }}</span>
          </div>
          <div class="card__row">
            <span class="card__label" i18n>Code postal</span>
            <span class="card__value">{{
              asDisplayValue(userProfile()?.postCode)
            }}</span>
          </div>
        </div>
      </app-card>

      <div class="customer-profile-panel__column">
        <app-card>
          <span cardTitle i18n>Courtiers</span>
          <div cardRows class="card__rows">
            <div class="card__row">
              <span class="card__label" i18n>Partenaire</span>
              @if (userProfile()?.partnerId) {
                <a
                  class="card__value customer-profile-panel__link"
                  [routerLink]="['/partners/view', userProfile()?.partnerId]"
                >
                  {{ asDisplayValue(userProfile()?.partnerName) }}
                </a>
              } @else {
                <span class="card__value">{{
                  asDisplayValue(userProfile()?.partnerName)
                }}</span>
              }
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Conseiller</span>
              @if (userProfile()?.agentId) {
                <a
                  class="card__value customer-profile-panel__link"
                  [routerLink]="['/agents/view', userProfile()?.agentId]"
                >
                  {{ asDisplayValue(userProfile()?.agentName) }}
                </a>
              } @else {
                <span class="card__value">{{
                  asDisplayValue(userProfile()?.agentName)
                }}</span>
              }
            </div>
          </div>
        </app-card>

        <app-card>
          <span cardTitle i18n>Assuré</span>
          <div cardRows class="card__rows">
            <div class="card__row">
              <span class="card__label" i18n>Membre de famille</span>
              <span class="card__value">{{
                asDisplayValue(familyMemberName())
              }}</span>
            </div>
            <div class="card__row">
              <span class="card__label" i18n>Relation</span>
              <span class="card__value">{{ relationLabel }}</span>
            </div>
          </div>
        </app-card>

        <app-card>
          <span cardTitle i18n>Assurance</span>
          <div cardRows class="card__rows">
            <div class="card__row">
              <span class="card__label" i18n>Type d’assurance</span>
              <span class="card__value">{{ insuranceTypeLabel }}</span>
            </div>
            @if (changeReasons().length) {
              <div class="card__row">
                <span class="card__label" i18n>Action</span>
                <span class="card__value">{{ changeReasonLabel }}</span>
              </div>
            }
          </div>
        </app-card>
      </div>
    </div>
  </div>
</app-expansion-panel>
